/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { connect } from 'react-redux';
import {
  LinearProgress, TextField,
} from '@mui/material';
import { IAppState } from '../../../../state/reducers';
import {
  IProps,
  IStateProps,
  IDispatchProps,
  IState,
} from './interfaces';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogActionsOverride,
  ActionContainer,
} from '../../../Shared/styles/dialog';
import { VaultButton, Warning } from '../../../Shared';
import {
  ProgressContainer,
  StyledAvatar,
  TeamContainer,
  TeamsContainer,
  StyledToolTip,
  TextFilterContainer,
} from './styles';
import {
  IVendorTeamWithData,
  toggleVendorData,
} from '../../../../state/exchange/vendorData';

class VendorData extends React.Component<IProps, IState> {
  state: IState = {
    filterText: '',
  };

  render() {
    const {
      isLoading,
      teams,
      onClose,
    } = this.props;

    const {
      filterText,
    } = this.state;

    const teamsExist = teams && teams.length > 0;

    const renderTextFilter = () => {
      const handleTextFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== filterText) {
          this.setState({
            filterText: e.target.value,
          });
        }
      };

      if (!teamsExist) {
        return null;
      }

      return (
        <TextFilterContainer>
          <TextField
            id="outlined-secondary"
            placeholder="Filter by team name or team code"
            variant="outlined"
            fullWidth
            onChange={handleTextFilter}
            value={filterText}
            data-auto="teamFilter"
          />
        </TextFilterContainer>
      );
    };

    const filterTeams = (vendorTeams: IVendorTeamWithData[]): IVendorTeamWithData[] => {
      let filteredTeams: IVendorTeamWithData[] = [];
      if (filterText !== null) {
        const lowerCaseFilter = filterText.toLowerCase();
        filteredTeams = vendorTeams.filter((team) => {
          if (team.teamName.toLowerCase().includes(lowerCaseFilter)) {
            return true;
          }
          if (team.teamCode && team.teamCode.toLowerCase().includes(lowerCaseFilter)) {
            return true;
          }
          return false;
        });
      }
      return filteredTeams;
    };

    const renderTeams = () => (
      <>
        {(teams && teams.length > 0) && (
          <TeamsContainer>
            {filterTeams(teams).map((team, index) => {
              const qualiferString = team.exchangeQualifier.join(', ');
              return (
                <TeamContainer key={index} data-auto="SubscribeTeamListItem" data-teamcode={team.teamCode}>
                  <div>
                    <StyledAvatar
                      alt={team.teamName}
                      src={team.teamImage}
                    />
                    {team.teamName} ({team.teamCode ? team.teamCode : ''})
                  </div>
                  {qualiferString === '' && (
                    <span>No game parts shared</span>
                  )}
                  {qualiferString !== '' && (
                    <StyledToolTip title={qualiferString}>
                      <span>
                        {qualiferString}
                      </span>
                    </StyledToolTip>
                  )}
                </TeamContainer>
              );
            })}
          </TeamsContainer>
        )}
        <Warning
          isWarning={!teamsExist || filterTeams(teams).length === 0}
          message="No teams found"
        />
      </>
    );

    return (
      <>
        <DialogHeader>
          <DialogHeaderTitle data-auto="AuthorizedTeamsModal">
            Authorized Teams
          </DialogHeaderTitle>
        </DialogHeader>
        <ProgressContainer>
          {isLoading && <LinearProgress />}
        </ProgressContainer>
        {renderTextFilter()}
        {renderTeams()}
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <VaultButton
              variant="primaryOnWhite"
              onClick={() => { onClose(); }}
              data-auto="AuthTeamsCloseBtn"
            >
              Close
            </VaultButton>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isLoading: state.exchange.vendorData.isLoading,
  teams: state.exchange.vendorData.teams,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleVendorData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VendorData);
